<template>
  <table class="print-table">
    <thead>
      <tr>
        <th width="24">序号</th>
        <th>品名</th>
        <th>工艺</th>
        <th>材质</th>
        <th>规格(mm)</th>
        <th>单位</th>
        <th>数量</th>
        <th>建议供应商</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in selfData" :key="index">
        <td>{{ index + 1 }}</td>
        <td>{{ item.craft }}</td>
        <td>{{ item.process_name }}</td>
        <td>{{ item.texture }}</td>
        <td>{{ item.specification }}</td>
        <td>{{ item.unit }}</td>
        <td>{{ item.shen_gou_stock_counts }}</td>
        <td>{{ item.jian_yi_supplier_name }}</td>
      </tr>
      <tr>
        <td>合计</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>{{ totalCounts }}</td>
        <td></td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selfData: [],
      totalCounts: 0
    }
  },
  mounted() {
    let result = this.$util.deepCopy(this.data)
    result.forEach((item) => {
      item.merge_str = `${item.craft}${item.process_name}${item.texture}${item.specification}${item.unit}`
    })
    this.selfData = this.$tool.getMergeCountListByName(result, 'merge_str', 'shen_gou_stock_counts')
    this.totalCounts = this.$util.listFieldTotal(this.selfData, 'shen_gou_stock_counts')
  }
}
</script>

<style lang="less" scoped>
.print-table {
  margin-top: 5px;
  width: 100%;
  border-collapse: collapse;
  border-left: 1px solid #000;
  border-top: 1px solid #000;
  text-align: center;
}
.print-table th,
.print-table td {
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
  padding: 2px;
  overflow-wrap: anywhere;
}
.print-table th {
  font-weight: normal;
  background: #e0e5eb;
}
</style>
